import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, inject, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Title, Meta } from '@angular/platform-browser';
import { ModalHomeComponent } from '../../components/home/modal-home/modal-home.component';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.scss'
})
export class HomePageComponent implements OnInit {

  activeRoute: ActivatedRoute = inject(ActivatedRoute);
  router = inject(Router);
  private readonly siteUrl = environment.SITE_URL;
  public showMapCdmx = false;
  public showMapToluca = false;
  public showMapOaxaca = false;

  constructor(
    private dialog: MatDialog,
    @Inject(PLATFORM_ID) private platformId: Object,
    private titleService: Title, private metaService: Meta,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.setMetaTags();
  }

  ngOnInit(): void {
    this.activeRoute.fragment.subscribe(fragment => {
      if (fragment) {
        setTimeout(() => {
          this.jumpToSection(fragment);
        }, 100);
      }
    });

    // this.router.events.pipe(
    //   filter(event => event instanceof NavigationEnd)
    // ).subscribe(() => {
    //   const fragment = this.activeRoute.snapshot.fragment;
    //   if (fragment) {
    //     setTimeout(() => {
    //       this.jumpToSection(fragment);
    //     }, 100);
    //   }
    // });
  }

  private jumpToSection(fragment: string) {
    if (isPlatformBrowser(this.platformId)) {
      const element = document.getElementById(fragment);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  public enableMap(map: 'cdmx' | 'toluca' | 'oaxaca'): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    if (map === 'cdmx') {
      this.showMapCdmx = true;
    } else if (map === 'toluca') {
      this.showMapToluca = true;
    } else {
      this.showMapOaxaca = true;
    }
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const openModal = sessionStorage.getItem('modalHomeShown');
      if (!openModal) {
        const open = () => {
          this.dialog.open(ModalHomeComponent, {
            disableClose: false,
            autoFocus: false,
          });
          sessionStorage.setItem('modalHomeShown', 'true');
        };

        const anyWindow = window as unknown as { requestIdleCallback?: (cb: () => void) => void };
        const schedule = () => {
          if (anyWindow.requestIdleCallback) {
            anyWindow.requestIdleCallback(open);
          } else {
            setTimeout(open, 1);
          }
        };

        const onFirstInteraction = () => {
          window.removeEventListener('pointerdown', onFirstInteraction);
          window.removeEventListener('scroll', onFirstInteraction);
          schedule();
        };

        window.addEventListener('pointerdown', onFirstInteraction, { passive: true } as AddEventListenerOptions);
        window.addEventListener('scroll', onFirstInteraction, { passive: true } as AddEventListenerOptions);
        setTimeout(onFirstInteraction, 8000);
      }
    }
  }

  setMetaTags() {
    const metaTitle = 'Paredes y Asociados Constructores';
    const metaDescription = 'Empresa constructora con más de 30 años de experiencia en proyectos industriales, comerciales, de infraestructura pública y salud en México.';
    const url = `${this.siteUrl}/`;
    const image = this.toAbsoluteUrl('/assets/images/logos/logo.png');

    this.titleService.setTitle(metaTitle);
    this.metaService.updateTag({ name: 'description', content: metaDescription });

    this.metaService.updateTag({ name: "robots", content: "index, follow" });
    this.metaService.updateTag({ name: "description", content: metaDescription });
    this.setCanonicalUrl(url);

    this.metaService.updateTag({ name: "keywords", content: "Paredes y Asociados, Construcciones, Arquitectos" });

    this.metaService.updateTag({ property: "og:type", content: "website" });
    this.metaService.updateTag({ property: "og:locale", content: "es_MX" });
    this.metaService.updateTag({ property: "og:site_name", content: "Paredes y Asociados" });

    this.metaService.updateTag({ property: "og:title", content: metaTitle });
    this.metaService.updateTag({ property: "og:description", content: metaDescription });
    this.metaService.updateTag({ property: "og:url", content: url });
    this.metaService.updateTag({ property: 'og:image', content: image });
    this.metaService.updateTag({ property: 'og:image:alt', content: 'Paredes y Asociados' });

    this.metaService.updateTag({ name: "twitter:card", content: "summary_large_image" });
    this.metaService.updateTag({ name: "twitter:title", content: metaTitle });
    this.metaService.updateTag({ name: "twitter:description", content: metaDescription });
    this.metaService.updateTag({ name: "twitter:url", content: url });
    this.metaService.updateTag({ name: "twitter:image", content: image });
  }

  private setCanonicalUrl(url: string): void {
    const head = this.document.head;
    let link = this.document.querySelector("link[rel='canonical']") as HTMLLinkElement | null;
    if (!link) {
      link = this.document.createElement('link');
      link.setAttribute('rel', 'canonical');
      head.appendChild(link);
    }
    link.setAttribute('href', url);
  }

  private toAbsoluteUrl(path: string): string {
    if (!path) {
      return `${this.siteUrl}/assets/images/logos/logo-full.webp`;
    }
    if (path.startsWith('http://') || path.startsWith('https://')) {
      return path;
    }
    if (!path.startsWith('/')) {
      path = `/${path}`;
    }
    return `${this.siteUrl}${path}`;
  }

}
